import { OPEN_SB_BTNS } from './sidebar-shopping';

const axios = require('axios');
const form = document.querySelector('form.js-product-detail');
const EDIT_BTNS = document.querySelectorAll('.js-edit-btn');
const CANCEL_BTNS = document.querySelectorAll('.js-cancel-btn');
const ORDERS = document.querySelectorAll('.c-cart__item__input');

export function init_add_to_cart() {

    if (! form) {
        return;
    }

    form.addEventListener('submit', submitToCard);
}

export function init_edit_qty() {

    if (! EDIT_BTNS) {
        return;
    }

    EDIT_BTNS.forEach(EDIT_BTN => {
        EDIT_BTN.addEventListener('click', openEditHandler)
    })

    if (! CANCEL_BTNS) {
        return;
    }

    CANCEL_BTNS.forEach(CANCEL_BTN => {
        CANCEL_BTN.addEventListener('click', closeEditHandler)
    })
}

function submitToCard(event)
{
    event.preventDefault();

    axios({
        method: form.getAttribute('method') ? form.getAttribute('method') : 'GET',
        url: form.getAttribute('action') ? form.getAttribute('action') : window.location.href,
        data: serialize(form),
    })
        .then(replaceCart)
        .catch(function (response) {
            alert('Er is iets mis gegaan, probeer het later nog eens');
        });
}

function replaceCart(response)
{
    if (! response.data.success) {
        var keys = Object.keys(response.data.errors)[0];
        keys = response.data.errors[keys];

        for(var i = 0; i < keys.length; i++) {
            let node = document.createElement("span");
            node.innerText = keys[i]; 
            form.querySelector('.js-cart-actions').appendChild(node);    
        }
    }else {

        axios.get(window.location.href)
            .then(function (response) {
                const CLASSNAME = '.js-shopping-cart .js-cart-body';
                
                let cart = document.querySelector(CLASSNAME);
                let dom = document.createElement('html');
                dom.innerHTML = response.data;
              
                cart.innerHTML = dom.querySelector(CLASSNAME).innerHTML;

                OPEN_SB_BTNS[0].click();

                document.querySelectorAll('.js-edit-btn').forEach(EDIT_BTN => {
                    EDIT_BTN.addEventListener('click', openEditHandler)
                })

                console.log('update cart 3');
          });
        }
}

/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
var serialize = function (form) {

    // Setup our serialized data
    var serialized = [];

    // Loop through each field in the form
    for (var i = 0; i < form.elements.length; i++) {

        var field = form.elements[i];

        // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
        if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

        // Convert field data to a query string
        else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
            serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
        }
    }

    return serialized.join('&');

};

function openEditHandler(e) {
    const SELECTED_ITEM_ID = e.target.dataset.itemId
    ORDERS.forEach(ORDER => {
        if (ORDER.dataset.itemId == SELECTED_ITEM_ID) {
            ORDER.classList.add('in-edit-mode')
        }
    })
}

function closeEditHandler(e) {
    const SELECTED_ITEM_ID = e.target.dataset.itemId
    ORDERS.forEach(ORDER => {
        if (ORDER.dataset.itemId == SELECTED_ITEM_ID) {
            ORDER.classList.remove('in-edit-mode')
        }
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/scripts/cart.js